import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "action-toolbar"
};
const _hoisted_2 = {
  key: 0,
  class: "mb-3 text-amber-600 text-sm"
};
const _hoisted_3 = {
  class: "data-table-shell"
};
const _hoisted_4 = {
  class: "data-table-scroll"
};
const _hoisted_5 = {
  class: "data-table text-sm"
};
const _hoisted_6 = {
  class: "data-table-head"
};
const _hoisted_7 = {
  key: 0,
  class: "data-table-th text-center w-44"
};
const _hoisted_8 = {
  class: "data-table-td"
};
const _hoisted_9 = {
  class: "text-sm font-medium text-slate-800 break-all"
};
const _hoisted_10 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_11 = {
  class: "text-sm text-slate-600"
};
const _hoisted_12 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_13 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_14 = {
  class: "data-table-td"
};
const _hoisted_15 = ["title"];
const _hoisted_16 = {
  key: 0,
  class: "data-table-td is-center whitespace-nowrap"
};
const _hoisted_17 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_18 = ["onClick"];
const _hoisted_19 = ["onClick"];
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  key: 1,
  class: "empty-state"
};
const _hoisted_26 = {
  key: 2,
  class: "flex items-center justify-center py-8"
};
const _hoisted_27 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_28 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_29 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_30 = {
  class: "space-y-4"
};
const _hoisted_31 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3 shrink-0"
};
const _hoisted_32 = ["disabled"];
const _hoisted_33 = {
  class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
};
const _hoisted_34 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_35 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3 shrink-0"
};
const _hoisted_36 = ["disabled"];
import { ref, reactive, computed, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useUserStore } from '@/stores/user';
import { meetingApi } from '@/api/meeting';
import { formatDateTime } from '@/utils/dateFormat';
import AppModal from '@/components/AppModal.vue';
const PAGE_SIZE = 50;

// 状态徽章颜色映射（文案直接使用后端 statusDesc 字段）

export default {
  __name: 'ActionItemPanel',
  props: {
    meetingId: {
      type: [Number, String],
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    // 待召开 + 当前用户为会议组织者/主持人（由详情抽屉按归属计算传入）
    canManage: {
      type: Boolean,
      default: false
    },
    // 当前用户为会议组织者/主持人（不限会议状态，催办用——已结束会议的未完成决策项仍可催办）
    isManager: {
      type: Boolean,
      default: false
    },
    // 决策项负责人候选（会议相关人员：参会人 + 组织者/主持人，由详情抽屉传入）
    candidates: {
      type: Array,
      default: () => []
    }
  },
  emits: ['changed'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    // 决策项发生写操作后通知父组件（详情抽屉需刷新决策项进度等聚合数据）
    const emit = __emit;

    // 归属判断：决策项处理（流转/进展）仅负责人本人可执行，管理者只能创建/编辑/删除（后端归属授权强制，此处只做 UI 显隐）
    const userStore = useUserStore();
    const currentUserId = computed(() => userStore.userInfo?.userId);
    const canOperateItem = row => {
      if (props.readonly) return false;
      if (currentUserId.value == null) return false;
      return Number(row.assigneeId) === Number(currentUserId.value);
    };

    // 负责人候选选项：编辑回填的负责人可能不在候选内（如已被移出参会人），兜底补一项避免显示裸 ID
    const candidateOptions = computed(() => {
      const options = [...props.candidates];
      if (form.assigneeId != null && !options.some(c => Number(c.id) === Number(form.assigneeId))) {
        const fallback = assigneeNames.value[form.assigneeId];
        options.push({
          id: form.assigneeId,
          name: fallback || `用户#${form.assigneeId}`
        });
      }
      return options;
    });

    // 一期决策项数量小，固定 size=50 不分页，配合截断提示
    const ACTION_STATUS_CLASS = {
      PENDING: 'is-neutral',
      IN_PROGRESS: 'is-info',
      DONE: 'is-success',
      CANCELLED: 'is-danger'
    };

    // 列表数据
    const loading = ref(false);
    const records = ref([]);

    // 负责人姓名缓存（后端 ActionItemDTO 无 assigneeName：
    // 新增/编辑时从 UserSelector confirm 拿 name 存本地 Map，表格查不到则显示 #id，一期接受）
    const assigneeNames = ref({});

    // 弹窗状态
    const showFormModal = ref(false);
    const editingItem = ref(null);
    const saving = ref(false);
    const form = reactive({
      title: '',
      content: '',
      assigneeId: null,
      deadline: ''
    });
    const showProgressModal = ref(false);
    const progressItem = ref(null);
    const progressNote = ref('');
    const savingProgress = ref(false);

    // 拉取决策项列表
    const fetchList = async () => {
      if (!props.meetingId) return;
      loading.value = true;
      try {
        const data = await meetingApi.getActionItemList({
          meetingId: props.meetingId,
          page: 1,
          size: PAGE_SIZE
        });
        records.value = data?.records || [];
      } catch (error) {
        ElMessage.error('获取决策项列表失败');
        console.error('获取决策项列表失败:', error);
      } finally {
        loading.value = false;
      }
    };
    watch(() => props.meetingId, () => {
      fetchList();
    }, {
      immediate: true
    });

    // 负责人显示：优先后端 assigneeName，其次本地姓名缓存，查不到显示 #id
    const assigneeDisplay = row => {
      if (row.assigneeName) return row.assigneeName;
      if (row.assigneeId === null || row.assigneeId === undefined) return '-';
      return assigneeNames.value[row.assigneeId] || `#${row.assigneeId}`;
    };

    // 逾期判断：未完成（PENDING/IN_PROGRESS）且截止时间早于当前
    const isOverdue = row => {
      if (!row.deadline) return false;
      if (row.status !== 'PENDING' && row.status !== 'IN_PROGRESS') return false;
      const deadline = new Date(String(row.deadline).replace(' ', 'T'));
      return deadline.getTime() < Date.now();
    };

    // 状态流转（confirm 取消时静默忽略）
    const handleTransit = async (row, status) => {
      const actionText = {
        IN_PROGRESS: '开始处理',
        DONE: '完成',
        CANCELLED: '取消'
      }[status];
      try {
        await ElMessageBox.confirm(`确认${actionText}决策项「${row.title}」？`, '提示', {
          type: 'warning'
        });
        await meetingApi.updateActionItemStatus(row.id, {
          status
        });
        ElMessage.success('操作成功');
        fetchList();
        emit('changed');
      } catch (error) {
        if (error !== 'cancel') {
          console.error('决策项状态流转失败:', error);
        }
      }
    };

    // 催办决策项（仅组织者/主持人可见；后端每日一次幂等，重复催办直接成功返回，无需特殊处理）
    const handleUrge = async row => {
      try {
        await ElMessageBox.confirm('确认催办该决策项负责人？', '提示', {
          type: 'warning'
        });
        await meetingApi.urgeActionItem(row.id);
        ElMessage.success('已催办');
      } catch (error) {
        if (error !== 'cancel') {
          // 错误已由拦截器提示
          console.error('催办决策项失败:', error);
        }
      }
    };

    // 删除决策项
    const handleDelete = async row => {
      try {
        await ElMessageBox.confirm(`确定要删除决策项「${row.title}」吗？`, '提示', {
          type: 'warning'
        });
        await meetingApi.deleteActionItem(row.id);
        ElMessage.success('决策项已删除');
        fetchList();
        emit('changed');
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('删除决策项失败');
          console.error('删除决策项失败:', error);
        }
      }
    };

    // 新增决策项
    const handleCreate = () => {
      editingItem.value = null;
      Object.assign(form, {
        title: '',
        content: '',
        assigneeId: null,
        deadline: ''
      });
      showFormModal.value = true;
    };

    // 编辑决策项
    const handleEdit = row => {
      editingItem.value = row;
      Object.assign(form, {
        title: row.title || '',
        content: row.content || '',
        assigneeId: row.assigneeId ?? null,
        deadline: row.deadline || ''
      });
      showFormModal.value = true;
    };

    // el-select 选择负责人时缓存姓名（表格兜底展示用）
    watch(() => form.assigneeId, val => {
      if (val == null) return;
      const hit = props.candidates.find(c => Number(c.id) === Number(val));
      if (hit?.name) {
        assigneeNames.value[val] = hit.name;
      }
    });

    // 提交新增/编辑
    const handleSubmit = async () => {
      if (!form.title?.trim()) {
        ElMessage.warning('请输入决策项标题');
        return;
      }
      if (!form.assigneeId) {
        ElMessage.warning('请选择负责人');
        return;
      }
      if (!form.deadline) {
        ElMessage.warning('请选择截止时间');
        return;
      }
      saving.value = true;
      try {
        const payload = {
          title: form.title.trim(),
          content: form.content,
          assigneeId: form.assigneeId,
          deadline: form.deadline
        };
        if (editingItem.value?.id) {
          await meetingApi.updateActionItem(editingItem.value.id, payload);
          ElMessage.success('决策项已更新');
        } else {
          await meetingApi.createActionItem(props.meetingId, payload);
          ElMessage.success('决策项已创建');
        }
        showFormModal.value = false;
        fetchList();
        emit('changed');
      } catch (error) {
        // 错误已由拦截器提示
        console.error('保存决策项失败:', error);
      } finally {
        saving.value = false;
      }
    };

    // 打开写进展弹窗
    const handleOpenProgress = row => {
      progressItem.value = row;
      progressNote.value = row.progressNote || '';
      showProgressModal.value = true;
    };

    // 保存进展
    const handleSaveProgress = async () => {
      if (!progressNote.value?.trim()) {
        ElMessage.warning('请输入进展说明');
        return;
      }
      savingProgress.value = true;
      try {
        await meetingApi.updateActionItemProgress(progressItem.value.id, {
          progressNote: progressNote.value.trim()
        });
        ElMessage.success('进展已保存');
        showProgressModal.value = false;
        fetchList();
        emit('changed');
      } catch (error) {
        // 错误已由拦截器提示
        console.error('保存进展失败:', error);
      } finally {
        savingProgress.value = false;
      }
    };
    __expose({
      fetchList
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_cache[12] || (_cache[12] = _createElementVNode("p", {
        class: "text-sm text-slate-500"
      }, "决策项将自动生成负责人的待办", -1)), __props.canManage ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "btn-primary inline-flex items-center gap-2",
        onClick: handleCreate
      }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
        class: "h-4 w-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M12 4v16m8-8H4"
      })], -1), _createTextVNode(" 新增决策项 ", -1)]))])) : _createCommentVNode("", true)]), records.value.length === PAGE_SIZE ? (_openBlock(), _createElementBlock("p", _hoisted_2, " 决策项较多，仅显示前 50 条 ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("table", _hoisted_5, [_createElementVNode("thead", _hoisted_6, [_createElementVNode("tr", null, [_cache[13] || (_cache[13] = _createElementVNode("th", {
        class: "data-table-th text-left"
      }, "标题", -1)), _cache[14] || (_cache[14] = _createElementVNode("th", {
        class: "data-table-th text-left w-28"
      }, "负责人", -1)), _cache[15] || (_cache[15] = _createElementVNode("th", {
        class: "data-table-th text-left w-40"
      }, "截止时间", -1)), _cache[16] || (_cache[16] = _createElementVNode("th", {
        class: "data-table-th text-left w-24"
      }, "状态", -1)), _cache[17] || (_cache[17] = _createElementVNode("th", {
        class: "data-table-th text-left w-48"
      }, "最新进展", -1)), !__props.readonly ? (_openBlock(), _createElementBlock("th", _hoisted_7, "操作")) : _createCommentVNode("", true)])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, row => {
        return _openBlock(), _createElementBlock("tr", {
          key: row.id,
          class: "data-table-row"
        }, [_createElementVNode("td", _hoisted_8, [_createElementVNode("p", _hoisted_9, _toDisplayString(row.title), 1)]), _createElementVNode("td", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(assigneeDisplay(row)), 1)]), _createElementVNode("td", _hoisted_12, [_createElementVNode("span", {
          class: _normalizeClass(isOverdue(row) ? 'text-sm font-medium text-red-600' : 'text-sm text-slate-600')
        }, _toDisplayString(_unref(formatDateTime)(row.deadline) || '-'), 3)]), _createElementVNode("td", _hoisted_13, [_createElementVNode("span", {
          class: _normalizeClass(['status-badge', ACTION_STATUS_CLASS[row.status] || 'is-neutral'])
        }, _toDisplayString(row.statusDesc || row.status), 3)]), _createElementVNode("td", _hoisted_14, [_createElementVNode("p", {
          class: "max-w-48 truncate text-sm text-slate-600",
          title: row.progressNote || ''
        }, _toDisplayString(row.progressNote || '-'), 9, _hoisted_15)]), !__props.readonly ? (_openBlock(), _createElementBlock("td", _hoisted_16, [_createElementVNode("div", _hoisted_17, [row.status === 'PENDING' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [canOperateItem(row) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "table-action-button is-success",
          title: "开始处理",
          "aria-label": "开始处理",
          onClick: $event => handleTransit(row, 'IN_PROGRESS')
        }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"
        }), _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        })], -1)]))], 8, _hoisted_18)) : _createCommentVNode("", true), canOperateItem(row) ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "table-action-button is-primary",
          title: "完成",
          "aria-label": "完成",
          onClick: $event => handleTransit(row, 'DONE')
        }, [...(_cache[19] || (_cache[19] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        })], -1)]))], 8, _hoisted_19)) : _createCommentVNode("", true)], 64)) : row.status === 'IN_PROGRESS' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [canOperateItem(row) ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "table-action-button is-primary",
          title: "完成",
          "aria-label": "完成",
          onClick: $event => handleTransit(row, 'DONE')
        }, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M5 13l4 4L19 7"
        })], -1)]))], 8, _hoisted_20)) : _createCommentVNode("", true), canOperateItem(row) ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "table-action-button is-indigo",
          title: "写进展",
          "aria-label": "写进展",
          onClick: $event => handleOpenProgress(row)
        }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
        })], -1)]))], 8, _hoisted_21)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), row.status === 'PENDING' || row.status === 'IN_PROGRESS' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [__props.isManager ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "table-action-button is-warning",
          title: "催办",
          "aria-label": "催办",
          onClick: $event => handleUrge(row)
        }, [...(_cache[22] || (_cache[22] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
        })], -1)]))], 8, _hoisted_22)) : _createCommentVNode("", true), __props.canManage ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "table-action-button is-primary",
          title: "编辑",
          "aria-label": "编辑",
          onClick: $event => handleEdit(row)
        }, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
        })], -1)]))], 8, _hoisted_23)) : _createCommentVNode("", true), __props.canManage ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "table-action-button is-danger",
          title: "删除",
          "aria-label": "删除",
          onClick: $event => handleDelete(row)
        }, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
        })], -1)]))], 8, _hoisted_24)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)]);
      }), 128))])])])]), records.value.length === 0 && !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[25] || (_cache[25] = [_createElementVNode("p", {
        class: "empty-state-title"
      }, "暂无决策项", -1)]))])) : _createCommentVNode("", true), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, [...(_cache[26] || (_cache[26] = [_createElementVNode("svg", {
        class: "w-8 h-8 animate-spin text-primary-500",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })], -1)]))])) : _createCommentVNode("", true), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: showFormModal.value,
          size: "md",
          onClose: _cache[6] || (_cache[6] = $event => showFormModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_27, [_createElementVNode("h3", _hoisted_28, _toDisplayString(editingItem.value ? '编辑决策项' : '新增决策项'), 1), _createElementVNode("button", {
            type: "button",
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer",
            onClick: _cache[0] || (_cache[0] = $event => showFormModal.value = false)
          }, [...(_cache[27] || (_cache[27] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 标题 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.title = $event),
            type: "text",
            placeholder: "请输入决策项标题",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.title]])]), _createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("label", {
            class: "form-label"
          }, "描述", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.content = $event),
            rows: "3",
            placeholder: "请输入决策项描述",
            class: "form-textarea"
          }, null, 512), [[_vModelText, form.content]])]), _createElementVNode("div", null, [_cache[30] || (_cache[30] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 负责人 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_select, {
            modelValue: form.assigneeId,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.assigneeId = $event),
            placeholder: "请选择负责人（会议相关人员）",
            filterable: "",
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(candidateOptions.value, c => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: c.id,
                label: c.name,
                value: c.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("label", {
            class: "form-label"
          }, [_createTextVNode(" 截止时间 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createVNode(_component_el_date_picker, {
            modelValue: form.deadline,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.deadline = $event),
            type: "datetime",
            placeholder: "请选择截止时间",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            class: "form-date w-full"
          }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[5] || (_cache[5] = $event => showFormModal.value = false)
          }, " 取消 "), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: saving.value,
            onClick: handleSubmit
          }, _toDisplayString(saving.value ? '保存中...' : '保存'), 9, _hoisted_32)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })])), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: showProgressModal.value,
          size: "sm",
          onClose: _cache[10] || (_cache[10] = $event => showProgressModal.value = false)
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_cache[33] || (_cache[33] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "写进展", -1)), _createElementVNode("button", {
            type: "button",
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer",
            onClick: _cache[7] || (_cache[7] = $event => showProgressModal.value = false)
          }, [...(_cache[32] || (_cache[32] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_34, [_cache[34] || (_cache[34] = _createElementVNode("label", {
            class: "form-label"
          }, "进展说明", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => progressNote.value = $event),
            rows: "4",
            placeholder: "请输入最新进展",
            class: "form-textarea"
          }, null, 512), [[_vModelText, progressNote.value]])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: _cache[9] || (_cache[9] = $event => showProgressModal.value = false)
          }, " 取消 "), _createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            disabled: savingProgress.value,
            onClick: handleSaveProgress
          }, _toDisplayString(savingProgress.value ? '保存中...' : '保存'), 9, _hoisted_36)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]))]);
    };
  }
};